export default __webpack_public_path__ + "static/media/thaigot-screenshot-06.54b276f4.png";